<template>
    <div class="informationPage scrollBar-custom" v-if="mixinUserInfo.platformType != 1">
        <div class="formTitle">司机信息</div>
        <Card header="基础信息">
            <el-form label-width="120px" label-position="left">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="司机姓名">{{ info.name || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系电话">{{ info.phone || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="机构名称">{{ info.organizationName || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机设备">{{ info.device || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="APP版本">{{ info.appVersion || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="mixinUserInfo.platformType == 3 || mixinUserInfo.platformType == 4">
                        <el-form-item label="归属渠道">{{ info.channelName || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8" v-else>
                        <el-form-item label="公司">
                            <span>{{ info.companyName || '-' }}</span>
                            <el-button type="text" size="medium" @click="editCompany">
                                <i class="el-icon-edit"></i>
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="紧急联系人">
                            <span>{{ info.emergency || '-' }}</span>
                            <el-button type="text" size="medium" @click="editEmergency">
                                <i class="el-icon-edit"></i>
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="紧急联系电话">{{ info.emergencyPhone || '-' }}</el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="mixinUserInfo.platformType == 3">
                        <el-form-item label="接单城市">
                            <span>{{ cityName || '-' }}</span>
                            <el-button type="text" size="medium" @click="editCity">
                                <i class="el-icon-edit"></i>
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Card>

        <div class="formTitle" style="margin-top: 32px;">证件信息</div>
        <Card>
            <template #header>
                <div class="flex" style="justify-content: space-between;">
                    <span>身份证信息</span>
                    <el-button type="text" size="medium" @click="editIdCard">更新</el-button>
                </div>
            </template>
            <el-form label-width="120px" label-position="left">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="身份证人像面">
                            <el-image :src="mixinQiniuImg(info.idCardFrontPath)" style="width: 200px; height: 135px;"
                                fit="cover" :preview-src-list="[mixinQiniuImg(info.idCardFrontPath)]"></el-image>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="身份证国徽面">
                            <el-image :src="mixinQiniuImg(info.idCardBackPath)" style="width: 200px; height: 135px;"
                                fit="cover" :preview-src-list="[mixinQiniuImg(info.idCardBackPath)]"></el-image>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="司机性别">
                            <span>{{ info.gender | filterConst('GENDER') }}</span>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <span>{{ info.idCard }}</span>
                        </el-form-item>
                        <el-form-item label="证件有效期至">
                            <span>{{ info.idCardValid == '4102329600' ? '长期有效' : info.idCardValidInput }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Card>
        <Card style="margin-top: 16px;">
            <template #header>
                <div class="flex" style="justify-content: space-between;">
                    <span>驾驶证信息</span>
                    <el-button type="text" size="medium" @click="editDriverLicense">更新</el-button>
                </div>
            </template>
            <el-form label-width="120px" label-position="left">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="驾驶证正页">
                            <el-image :src="mixinQiniuImg(info.driverLicensePath)" style="width: 200px; height: 135px;"
                                fit="cover" :preview-src-list="[mixinQiniuImg(info.driverLicensePath)]"></el-image>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="驾驶证副页">
                            <el-image :src="mixinQiniuImg(info.driverLicenseBackPath)"
                                style="width: 200px; height: 135px;" fit="cover"
                                :preview-src-list="[mixinQiniuImg(info.driverLicenseBackPath)]"></el-image>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="准驾车型">
                            <span>{{ info.driverClass }}</span>
                        </el-form-item>
                        <el-form-item label="初次领证日期">
                            <span>{{ info.firstIssueDate }}</span>
                        </el-form-item>
                        <el-form-item label="证件有效期至">
                            <span>{{ info.driverLicenceValid == '4102329600' ? '长期有效' : info.driverLicenceValidInput
                            }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Card>
        <Card style="margin: 16px 0;">
            <template #header>
                <div class="flex" style="justify-content: space-between;">
                    <span>从业资格证</span>
                    <el-button type="text" size="medium" @click="editQualification">更新</el-button>
                </div>
            </template>
            <el-form label-width="120px" label-position="left">
                <el-form-item label="从业资格证照片">
                    <el-image :src="mixinQiniuImg(info.qualificationsPath)" style="width: 200px; height: 135px;"
                        fit="cover" :preview-src-list="[mixinQiniuImg(info.qualificationsPath)]"></el-image>
                </el-form-item>
            </el-form>
        </Card>

        <id-card-dialog :visible.sync="idCardDialogVisible" :info="info" :loading="loading"
            @submit="handleIdCardSubmit"></id-card-dialog>
        <driver-license-dialog :visible.sync="driverLicenseDialogVisible" :driver-info="info" :loading="loading"
            @submit="handleDriverLicenseSubmit"></driver-license-dialog>
        <qualification-dialog :visible.sync="qualificationDialogVisible" :driver-info="info" :loading="loading"
            @submit="handleQualificationSubmit"></qualification-dialog>

        <el-dialog title="紧急联系人" :visible.sync="emergencyDialogVisible" width="400px" :close-on-click-modal="false"
            destroy-on-close>
            <el-form :model="emergencyForm" :rules="emergencyRules" ref="emergencyForm" label-width="120px"
                label-position="left">
                <el-form-item label="紧急联系人" prop="emergency">
                    <el-input v-model="emergencyForm.emergency" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="联系人电话" prop="emergencyPhone">
                    <el-input v-model="emergencyForm.emergencyPhone" maxlength="11"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="emergencyDialogVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="saveEmergency">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="归属公司" :visible.sync="editCompanyVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="editCompanyForm" :rules="editCompanyRules" ref="editCompanyForm" label-width="120px"
                label-position="left">
                <el-form-item label="司机归属公司" prop="companyName">
                    <el-input v-model="editCompanyForm.companyName" maxlength="20"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="editCompanyClose">取 消</el-button>
                <el-button size="medium" type="primary" @click="editCompanySave" :loading="loading">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="接单城市" :visible.sync="editCityVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="editCityForm" :rules="editCityRules" ref="editCityForm" label-width="120px"
                label-position="left">
                <el-form-item label="司机接单城市" prop="receivingCityCode">
                    <el-cascader filterable v-model="editCityForm.receivingCityCode" :props="props"
                        :options="cityOptions"></el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="editCityClose">取 消</el-button>
                <el-button size="medium" type="primary" @click="editCitySave" :loading="loading">确 认</el-button>
            </div>
        </el-dialog>
    </div>
    <div class="dz-page" v-else>
        <el-descriptions :column="2" size="medium" border>
            <el-descriptions-item label="身份证号">{{ info.idCard || '-' }}</el-descriptions-item>
            <el-descriptions-item label="司机性别">{{ info.gender | filterConst('GENDER') }}</el-descriptions-item>
            <el-descriptions-item label="身份证有效期">
                {{ info.idCardValid == 4102329600 ? '长期有效' : '短期有效' }}
            </el-descriptions-item>
            <el-descriptions-item label="有效期至">{{ info.idCardValid | filterTime('YYYY-MM-DD')
                }}</el-descriptions-item>
            <el-descriptions-item label="身份证人像面">
                <el-image :src="mixinQiniuImg(info.idCardFrontPath)" style="width: 200px; height: 135px;" fit="cover"
                    :preview-src-list="[mixinQiniuImg(info.idCardFrontPath)]"></el-image>
            </el-descriptions-item>
            <el-descriptions-item label="身份证国徽面">
                <el-image :src="mixinQiniuImg(info.idCardBackPath)" style="width: 200px; height: 135px;" fit="cover"
                    :preview-src-list="[mixinQiniuImg(info.idCardBackPath)]"></el-image>
            </el-descriptions-item>
        </el-descriptions>

        <el-descriptions :column="2" size="medium" border style="margin-top: 16px;">
            <el-descriptions-item label="准驾车型">{{ info.driverClass || '-' }}</el-descriptions-item>
            <el-descriptions-item label="初次领证日期">{{ info.firstIssueDate }}</el-descriptions-item>
            <el-descriptions-item label="驾驶证有效期">{{ info.driverLicenceValid == 4102329600 ? '长期有效' : '短期有效'
            }}</el-descriptions-item>
            <el-descriptions-item label="有效期至">{{ info.driverLicenceValid | filterTime('YYYY-MM-DD')
            }}</el-descriptions-item>
            <el-descriptions-item label="驾驶证正页">
                <el-image :src="mixinQiniuImg(info.driverLicensePath)" style="width: 200px; height: 135px;" fit="cover"
                    :preview-src-list="[mixinQiniuImg(info.driverLicensePath)]"></el-image>
            </el-descriptions-item>
            <el-descriptions-item label="驾驶证副页">
                <el-image :src="mixinQiniuImg(info.driverLicenseBackPath)" style="width: 200px; height: 135px;"
                    fit="cover" :preview-src-list="[mixinQiniuImg(info.driverLicenseBackPath)]"></el-image>
            </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="2" size="medium" border style="margin-top: 16px;">
            <el-descriptions-item label="从业资格证">
                <el-image :src="mixinQiniuImg(info.qualificationsPath)" style="width: 200px; height: 135px;" fit="cover"
                    :preview-src-list="[mixinQiniuImg(info.qualificationsPath)]"></el-image>
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
import { cityCodeJson } from "@/assets/js/city";
import idCardDialog from './idCardDialog.vue'
import driverLicenseDialog from './driverLicenseDialog.vue'
import qualificationDialog from './qualificationDialog.vue'

export default {
    components: {
        idCardDialog,
        driverLicenseDialog,
        qualificationDialog
    },
    data() {
        return {
            idCardDialogVisible: false,
            driverLicenseDialogVisible: false,
            qualificationDialogVisible: false,
            loading: false,

            emergencyDialogVisible: false,
            emergencyForm: {
                emergency: '',
                emergencyPhone: '',
            },
            emergencyRules: {
                emergency: [{ required: true, message: '请输入紧急联系人' }],
                emergencyPhone: [{ required: true, message: '请输入紧急联系人电话' }],
            },

            editCompanyVisible: false,
            editCompanyForm: {
                companyName: ''
            },
            editCompanyRules: {
                companyName: [{ required: false, message: '请输入司机归属公司' }]
            },

            props: {
                label: "name",
                value: "citycode",
                children: "districts",
            },
            cityOptions: cityCodeJson,
            editCityVisible: false,
            editCityForm: {
                receivingCityCode: [],
            },
            editCityRules: {
                receivingCityCode: [{ required: true, message: "请选择归属城市" }],
            },
        }
    },
    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        cityName() {
            return this.$utils.getCityName(cityCodeJson, this.info.receivingCityCode, "province");
        }
    },
    created() {
    },
    methods: {
        editCity() {
            this.editCityVisible = true;
            this.editCityForm.receivingCityCode = this.info.receivingCityCode;
        },
        editCityClose() {
            this.editCityVisible = false;
        },
        editCitySave() {
            this.$refs.editCityForm.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    let url = "/api/v1/manage/driver";
                    let receivingCityCode = Array.isArray(this.editCityForm.receivingCityCode)
                        ? this.editCityForm.receivingCityCode[this.editCityForm.receivingCityCode.length - 1]
                        : this.editCityForm.receivingCityCode;
                    let params = {
                        id: this.info.id,
                        receivingCityCode: receivingCityCode,
                        receivingCity: this.$utils.getCityName(cityCodeJson, receivingCityCode)
                    }
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.editCityVisible = false;
                        this.$emit("refresh");
                    }
                    this.loading = false;
                }
            });
        },
        editCompany() {
            this.editCompanyVisible = true
            this.editCompanyForm.companyName = this.info.companyName
        },
        editCompanyClose() {
            this.editCompanyVisible = false
        },
        editCompanySave() {
            this.$refs.editCompanyForm.validate(async (valid) => {
                if (valid) {
                    let url = '/api/v1/manage/driver'
                    let params = {
                        id: this.info.id,
                        companyName: this.editCompanyForm.companyName
                    }
                    this.loading = true
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.editCompanyVisible = false
                        this.$emit("refresh");
                    }
                    this.loading = false
                }
            })
        },
        editEmergency() {
            this.emergencyDialogVisible = true;
            this.emergencyForm.emergency = this.info.emergency;
            this.emergencyForm.emergencyPhone = this.info.emergencyPhone;
        },
        saveEmergency() {
            this.$refs.emergencyForm.validate(async (valid) => {
                if (valid) {
                    let url = "/api/v1/manage/driver";
                    let params = {
                        id: this.info.id,
                        emergency: this.emergencyForm.emergency,
                        emergencyPhone: this.emergencyForm.emergencyPhone,
                    };
                    let { code } = await this.$axios.put(url, params);
                    if (code === 1) {
                        this.$message.success("保存成功！");
                        this.emergencyDialogVisible = false;
                        this.$emit("refresh");
                    }
                }
            });
        },
        editIdCard() {
            this.idCardDialogVisible = true
        },
        editDriverLicense() {
            this.driverLicenseDialogVisible = true
        },
        editQualification() {
            this.qualificationDialogVisible = true
        },
        async handleIdCardSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/driver";
            let params = {
                id: this.info.id,
                ...formData,
                idCardValid: formData.idCardValid == '4102329600' ? 4102329600 : new Date(formData.idCardValidInput).setHours(0, 0, 0, 0) / 1000,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.idCardDialogVisible = false
            }
            this.loading = false
        },
        async handleDriverLicenseSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/driver";
            let params = {
                id: this.info.id,
                driverLicensePath: formData.driverLicensePath,
                driverLicenseBackPath: formData.driverLicenseBackPath,
                driverClass: formData.driverClass,
                firstIssueDate: new Date(formData.firstIssueDate).setHours(0, 0, 0, 0) / 1000,
                driverLicenceValid: formData.driverLicenceValid == '4102329600' ? 4102329600 : new Date(formData.driverLicenceValidInput).setHours(0, 0, 0, 0) / 1000,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.driverLicenseDialogVisible = false
            }
            this.loading = false
        },
        async handleQualificationSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/driver";
            let params = {
                id: this.info.id,
                qualificationsPath: formData.qualificationsPath,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.qualificationDialogVisible = false
            }
            this.loading = false
        }
    }
}
</script>

<style lang="less" scoped>
.dz-page {
    height: 100%;

    :deep(.el-descriptions) {
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }

    :deep(.el-descriptions)::after {
        content: '';
        pointer-events: none;
        position: absolute;
        inset: 0;
        border-radius: 8px;
        border: 1px solid #EBEEF5;
        z-index: 1;
    }

    :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 150px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }
}
</style>